export enum Rettighed {
  ProjektEjer = 0,
  Ansoeg = 1,
  Dokumentation = 2,
  Laes = 3,
}
